import React, { useEffect, useRef, useState } from 'react';
import styled from "styled-components";
import PreEFormMappingHeader from '../../PreEFormFields/PreEFormMappingHeader';
import PreEFormMapping from "../../../PreEForm/PreEFormMapping";
import Form from "react-bootstrap/Form";
import PreFormExceptionMapping from 'containers/PreEForm/PreFormExceptionMapping';
const CheckBoxContainer = styled.div`
    overflow-x: hidden;
    padding-left: 0px;
    border: 1px solid grey
`;

const IPSLocationAssetCollapse = ({ preEForm, preEFormMappings, assets, onChangeAssetId, selectAllAssets,saveVisibleText, handleCheckboxSelect, selectedLocationAssets, handleIpsLocationSelect,exceptionViewMode, editVisibleProps, checkBoxHidden }) => {
    const [contentHeight, setContentHeight] = useState(0);
    const content = useRef(null)

    useEffect(()=> {
        setContentHeight(content.current.scrollHeight)
    }, [preEFormMappings])
    return <CheckBoxContainer>
        <PreEFormMappingHeader />
        <div className='scroll-container' ref={content} style={{maxHeight: contentHeight<400? contentHeight<200?200:contentHeight :400}}>
        {preEFormMappings && preEFormMappings.length > 0 && preEFormMappings.map(preEFormMapping =>
            <PreFormExceptionMapping
                 key={preEFormMapping.ipsLocationId}
                 ipsLocationId={preEFormMapping.ipsLocationId}
                 onChangeAssetId={onChangeAssetId}
                 selectAllAssets={selectAllAssets}
                 preEFormMapping={preEFormMapping}
                 currentFormId = {preEForm?.id}
                 saveVisibleText={!saveVisibleText}
                 handleCheckboxSelect={handleCheckboxSelect}
                 handleIpsLocationSelect={handleIpsLocationSelect}
                 selectedAssets={selectedLocationAssets && selectedLocationAssets.filter(l=>l.ipsLocationId === preEFormMapping.ipsLocationId)}
                 exceptionViewMode={exceptionViewMode}
                 editVisibleProps={editVisibleProps}
                 checkBoxHidden={checkBoxHidden}
            />
        )}
</div>
    </CheckBoxContainer>;
}
export default IPSLocationAssetCollapse;